<div class="calendar-container">
      <div class="header-cal" style="background-color:{bgColor}; color: {textColor}">
            <div
                  class="btn-header-cal shadow"
                  on:click={() => changeMonth(-1)}
                  on:keypress={() => changeMonth(-1)}
            >
                  <IconoNico name="chevron-left" color="white" strokeW="15px" />
            </div>
            <div class="nombre-mes-header">
                  {arrNombreMeses[$currentDate.getMonth()]}, {$currentDate.getFullYear()}
            </div>
            <div
                  class="btn-header-cal shadow"
                  on:click={() => changeMonth(1)}
                  on:keypress={() => changeMonth(1)}
            >
                  <IconoNico name="chevron-right" color="white" strokeW="15px" />
            </div>
      </div>

      <div class="calendar">
            {#each arrCapsLettersDayOfTheWeek as capLetterDayOfTheWeek}
                  <div class="day bold">{capLetterDayOfTheWeek}</div>
            {/each}

            {#each generateCalendar($currentDate) as dayLoop}
                  <div
                        class="day {dayLoop.fecha === $selectedDate?.getDate() &&
                        dayLoop.numMes === $selectedDate?.getMonth()
                              ? 'selected'
                              : ''} {dayLoop.preMonth ? 'day-disabled' : ''}
                              {dayLoop.postMonth ? 'day-disabled' : ''}"
                        on:click={() => selectDate(dayLoop)}
                        on:keypress={() => selectDate(dayLoop)}
                  >
                        <!-- {JSON.stringify(dayLoop)} -->
                        {dayLoop.fecha}/
                        {dayLoop.numMes}
                        <!-- {day != null ? day : ""} -->
                  </div>
            {/each}
      </div>

      SELECTED:{JSON.stringify($selectedDate)}
      <br />

      sel:{$selectedDate?.getDate()}
      {#if $selectedDate}
            <div>Fecha seleccionada: {$selectedDate.toLocaleDateString()}</div>
      {/if}
</div>

<script>
      import { onMount } from "svelte";
      import IconoNico from "./IconoNico.svelte";
      import { writable } from "svelte/store";

      // Variables para la fecha seleccionada y el mes actual
      export let selectedDate = writable(null);
      let currentDate = writable(new Date());
      export let EN = false;
      export let bgColor = "#1abc9c";
      export let textColor = "white";
      let arrNombreMeses = [];
      let arrCapsLettersDayOfTheWeek = [];
      onMount(() => {
            if (EN) {
                  arrNombreMeses = arrNombreMesesEN;
                  arrCapsLettersDayOfTheWeek = arrCapsLettersDayOfTheWeekEN;
            } else {
                  arrNombreMeses = arrNombreMesesESP;
                  arrCapsLettersDayOfTheWeek = arrCapsLettersDayOfTheWeekESP;
            }
      });

      const arrNombreMesesESP = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
      ];
      const arrNombreMesesEN = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
      ];
      const arrCapsLettersDayOfTheWeekESP = ["L", "M", "X", "J", "V", "S", "D"];
      const arrCapsLettersDayOfTheWeekEN = ["M", "T", "W", "T", "F", "S", "S"];

      // Generar días del calendario para el mes actual
      function generateCalendar(date) {
            let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            let days = [];
            let dayOfWeek = firstDay.getDay(); // Día de la semana del primer día del mes
            let numberOfDays = lastDay.getDate(); // Número total de días del mes

            // Calcular los días del mes anterior
            let prevMonthDays = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Si el primer día es domingo, tomamos 6 días del mes anterior

            // Agregar días del mes anterior
            let prevMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            for (let i = prevMonthDays; i > 0; i--) {
                  let prevDay = new Date(
                        prevMonth.getFullYear(),
                        prevMonth.getMonth(),
                        prevMonth.getDate() - i
                  );
                  days.push({
                        fecha: prevDay.getDate(),
                        numMes: date.getMonth() - 1,
                        preMonth: true,
                        postMonth: false,
                  });
            }

            // Agregar los días del mes actual
            for (let i = 1; i <= numberOfDays; i++) {
                  days.push({
                        fecha: i,
                        numMes: date.getMonth(),
                        preMonth: false,
                        postMonth: false,
                  });
            }

            // Calcular cuántos días del mes siguiente necesitamos
            let remainingDays = 7 - (days.length % 7);
            if (remainingDays < 7) {
                  let nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
                  for (let i = 1; i < remainingDays; i++) {
                        days.push({
                              fecha: i,
                              numMes: date.getMonth() + 1,
                              preMonth: false,
                              postMonth: true,
                        });
                  }
            }

            return days;
      }
      //   function generateCalendar(date) {
      //         let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      //         let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      //         let days = [];
      //         let dayOfWeek = firstDay.getDay();
      //         let numberOfDays = lastDay.getDate();

      //         // Agregar espacios en blanco antes del primer día
      //         for (let i = 0; i < dayOfWeek; i++) {
      //               days.push(null);
      //         }

      //         // Agregar los días del mes
      //         for (let i = 1; i <= numberOfDays; i++) {
      //               days.push(i);
      //         }

      //         return days;
      //   }

      // Cambiar el mes
      function changeMonth(direction) {
            const newDate = new Date($currentDate);
            newDate.setMonth(newDate.getMonth() + direction);
            currentDate.set(newDate);
      }

      // Seleccionar fecha
      function selectDate(day) {
            if (day) {
                  let realDay = day?.fecha;
                  const dateAUX = new Date($currentDate);
                  dateAUX.setDate(realDay);

                  if (day.preMonth) {
                        console.log("PRE");
                        dateAUX.setMonth(dateAUX.getMonth() - 1);
                  }
                  if (day.postMonth) {
                        console.log("POST");
                        dateAUX.setMonth(dateAUX.getMonth() + 1);
                  }
                  selectedDate.set(dateAUX);
            }
      }
</script>

<style>
      .calendar-container {
            max-width: 350px;
            margin: auto;
            text-align: center;
      }

      .calendar {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            gap: 5px;
            margin-top: 10px;
      }

      .day {
            padding: 10px;
            text-align: center;
            cursor: pointer;
            border-radius: 50px;
            border: solid 1px lightgrey;
            transition: background-color 0.2s;
      }

      .day:hover {
            background-color: #f0f0f0;
      }

      .selected {
            background-color: #007bff !important;
            color: white;
      }

      .nombre-mes-header {
            font-size: 18px;
            font-weight: bold;
            padding-top: 8px;
            padding-bottom: 8px;
      }
      .day-disabled {
            color: gray;
            /* cursor: not-allowed; */
            background-color: lightgrey;
      }
      .header-cal {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            border-radius: 50px;
            overflow: hidden;
      }
      .shadow {
            background-color: rgba(0, 0, 0, 0.25);
            color: white;
      }
      .btn-header-cal {
            padding: 8px;
      }
      button {
            outline: none;
      }
</style>
